import Modal from "@mui/material/Modal";
import CloseIcon from "@mui/icons-material/Close";
import { Box, IconButton, Tab, Tabs, useTheme } from "@mui/material";
import { useState } from "react";
import { CommentsFileUploadSection } from "./CommentFileUploadSection";
import { DownloadTemplateFiles } from "./DownloadTemplateFiles";
import PropTypes from "prop-types";
import { tokens } from "../../../../../theme";

interface ImportCommentsModalProps {
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
  fetchComments: (initialFetch: boolean) => Promise<void>;
}

type displayModeType = "select-data" | "confirm-data" | "key-mapping";
interface modalBoxPropertiesType {
  width: number | string;
  height: number | string;
  marginInline: string;
  marginTop: string;
  top: string;
  left: string;
  transform: string;
}

export const ImportCommentsModal: React.FC<ImportCommentsModalProps> = ({
  setOpen,
  fetchComments,
}) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const [displayMode] = useState<displayModeType>("select-data");
  const [value, setValue] = useState(0);
  const [modalBoxProps, setModalBoxProps] = useState<modalBoxPropertiesType>({
    width: 500,
    height: "auto",
    marginInline: "inherit",
    marginTop: "inherit",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
  });

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  const changeTheWidthForVerifyData = (toDefault: boolean) => {
    if (toDefault) {
      setModalBoxProps({
        width: 500,
        height: "auto",
        marginInline: "inherit",
        marginTop: "inherit",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
      });
      return;
    }
    setModalBoxProps({
      width: "80%",
      height: "90%",
      marginInline: "auto",
      marginTop: "3rem",
      top: "50%",
      left: "50%",
      transform: "translate(-60%,-55%)",
    });
  };

  return (
    <Modal
      open={true}
      //onClose={() => setOpen(false)}
      aria-labelledby="syncing-comments-modal"
      aria-describedby="syncing-comments-modal-description"
    >
      <>
        {displayMode === "select-data" && (
          <Box
            sx={{
              borderRadius: "1.2rem",
              position: "relative",
              top: "50%",
              left: "50%",
              transform: modalBoxProps.transform,
              width: modalBoxProps.width,
              height: modalBoxProps.height,
              marginInline: modalBoxProps.marginInline,
              marginTop: modalBoxProps.marginTop,
              bgcolor: colors.primary[900],
              boxShadow: 24,
              transition: ".2s ease-in-out",
            }}
          >
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                padding: "0 .5em",
                borderBottom: `1px solid whitesmoke`,
              }}
            >
              <Tabs value={value} onChange={handleChange}>
                <Tab label="File Upload" />
                <Tab label="Download Templates" />
              </Tabs>

              <IconButton sx={{ "&:hover": { color: "#a60b0bff" } }}>
                <CloseIcon onClick={() => setOpen(false)} />
              </IconButton>
            </Box>

            {value === 0 ? (
              <CommentsFileUploadSection
                setOpen={setOpen}
                fetchComments={fetchComments}
                changeModalProps={changeTheWidthForVerifyData}
              />
            ) : (
              <DownloadTemplateFiles />
            )}
          </Box>
        )}
      </>
    </Modal>
  );
};

ImportCommentsModal.propTypes = {
  setOpen: PropTypes.func.isRequired,
  fetchComments: PropTypes.func.isRequired,
};
